module.exports = __webpack_public_path__ + "static/profile-3-c6a4fd058567b143324fb3f6649bae31.jpg";